// IV Biotics — header language switcher. Native <details> handles open/close;
// this adds outside-click and Escape-to-close for a polished dropdown feel.
class IvbLanguageSwitcher extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('.ivb-lang__details');
    if (!this.details) return;

    this.onDocClick = (e) => {
      if (this.details.open && !this.contains(e.target)) this.details.open = false;
    };
    this.onKeydown = (e) => {
      if (e.key === 'Escape' && this.details.open) {
        this.details.open = false;
        this.querySelector('.ivb-lang__toggle')?.focus();
      }
    };

    document.addEventListener('click', this.onDocClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
    this.removeEventListener('keydown', this.onKeydown);
  }
}

if (!customElements.get('ivb-language-switcher')) {
  customElements.define('ivb-language-switcher', IvbLanguageSwitcher);
}
